var iwaMiddleware = function (dispatch) { return function (next, done) { return function (message) {
    // @TODO Move all iwa domain handlers here
    if (message.domain !== 'iwa' && message.eventType !== 'http') {
        return next(message);
    }
    switch (message.eventType) {
        case 'http':
            var data = message.data.data;
            fetch(data.url, data).then(function (res) {
                return dispatch({
                    purpose: 'response',
                    eventType: 'http',
                    request_id: message.data.request_id,
                    response_data: res,
                });
            });
            done();
            break;
        case 'navigate_back':
            window.history.back();
            done();
            break;
        default:
            console.warn('Unhandled iwa domain event', message);
            return next(message);
    }
}; }; };
export default iwaMiddleware;
//# sourceMappingURL=iwa.js.map